if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"][name="add"]');
        this.applyDiscountButton = this.querySelector('#apply_discount');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (this.applyDiscountButton) {
          this.applyDiscountButton.addEventListener(
            'click',
            (evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              evt.stopImmediatePropagation();
              this.onSubmitHandler(evt);
            },
            true
          );
        }

        this.setBookNowLabel();
      }

      setBookNowLabel() {
        if (!this.submitButton) return;

        const span = this.submitButton.querySelector('span');
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (!span) return;
        if (soldOutMessage && !soldOutMessage.classList.contains('hidden')) return;

        span.textContent = 'Book Now';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        if (this.applyDiscountButton) {
          this.applyDiscountButton.setAttribute('disabled', 'disabled');
        }

        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);

        const discountInput = this.form.querySelector('#discount_code');
        const discountCode = discountInput ? discountInput.value.trim() : '';

        try {
          await fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const response = await addResponse.json();

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          if (discountCode) {
            window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`;
          } else {
            window.location.href = '/checkout';
          }
        } catch (e) {
          console.error('Book Now checkout error:', e);
          this.handleErrorMessage('Something went wrong. Please try again.');
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (this.applyDiscountButton) {
            this.applyDiscountButton.removeAttribute('disabled');
          }

          if (spinner) spinner.classList.add('hidden');

          this.setBookNowLabel();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}